import React from "react";

const CardGroupTitle = (props) => {
  return (
    <div>
      <h5>{props.titleText}</h5>
    </div>
  );
};

export default CardGroupTitle;
